export default __webpack_public_path__ + "static/media/5A7181F7-7AD9-40F6-94C5-BE9635AED098.f5963b0b.jpeg";